const skillsDesign = [
    { text: 'Photoshop', icon: 'skill_intermediate.png'},
    { text: 'Illustrator', icon: 'skill_intermediate.png'},
    { text: 'Premiere', icon: 'skill_beginner.png'},
    { text: 'Audacity', icon: 'skill_beginner.png'},
  ];
  
  export default skillsDesign;